import { ListGroupItem, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StudentStatus from "../Student/StudentStatus";
import moment from "moment";
import TeacherModuleAnswersAndDocs from "../Teacher/TeacherModuleAnswersAndDocs";
import axios from "../../services/api/api";
import { API_BASE_URL } from "../../constants/api.constants";
import { toast } from "react-toastify";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { injectIntl } from "react-intl";
import { FormattedMessage } from "react-intl";

const TeacherModule = (props) => {
  let mappedStatus;
  let mappedTime;

  if (props.showStatus && props.module.students.length > 0) {
    mappedStatus = (
      <StudentStatus
        className=""
        status={props.module.students[0].status}
      ></StudentStatus>
    );
    mappedTime = (
      <div className="small mw-100 mt-1 text-right" title="Senast körd">
        <FontAwesomeIcon icon="clock" className="text-secondary" />
        &nbsp;
        {moment(props.module.students[0].lastRun).format("YY-MM-DD HH:mm")}
      </div>
    );
  }

  const showAnswers =
    !props.module.isFactModule &&
    !(props.module.isGy25 && props.module.isFinalExam);

  const showStudyTasks = props.module.isFactModule && props.studyTasksAvailable;

  const handleOpenStudyTasks = () => {
    axios
      .get(
        `${API_BASE_URL}/Module/GetModuleStudyTasks?moduleId=${props.module.moduleId}`,
        {
          responseType: "blob",
        },
      )
      .then((response) => {
        const filename =
          props.studyTasksFileName ||
          `instuderingsuppgifter_${props.module.moduleId}`;

        const file = new Blob([response.data], {
          type: response.data.type || "application/octet-stream",
        });
        const fileURL = URL.createObjectURL(file);

        const link = document.createElement("a");
        link.href = fileURL;
        link.download = filename;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(fileURL);
      })
      .catch(async (error) => {
        let responseObj = await error.response.data.text();
        if (responseObj.trim() === "FileNotFound") {
          toast.warn(
            props.intl.formatMessage({ id: "StudyTasksFileNotFound" }),
            TOAST_CONFIG,
          );
        } else {
          toast.warn(
            responseObj || props.intl.formatMessage({ id: "GenericApiError" }),
            TOAST_CONFIG,
          );
        }
      });
  };

  return (
    <ListGroupItem className="px-2">
      <div className="d-flex align-items-center w-100">
        <Button
          className="m-0 p-0 me-2 flex-shrink-0"
          size="sm"
          color="link"
          title="Starta kursen"
          onClick={(e) => {
            props.runModule(
              props.courseId,
              props.module.moduleId,
              props.module.url,
              props.module.moduleType,
              props.module.isFinalExam && props.module.isGy25,
            );
          }}
        >
          <FontAwesomeIcon icon="play-circle" size="2x" />
        </Button>

        <span
          className="text-truncate module-name-col"
          title={props.module.name}
        >
          {props.module.name}
        </span>

        <div className="ms-auto d-flex align-items-center ps-2 min-w-0">
          <Button
            size="sm"
            color="link"
            disabled={props.disabled}
            className={`flex-shrink-0 ${props.showResult ? "" : "d-none"}`}
            title={
              props.disabled
                ? "Det finns inga resultat ännu"
                : "Se alla resultat för denna modul"
            }
            onClick={(e) => {
              props.navigateToResult(
                props.courseId,
                props.module.courseModuleId,
              );
            }}
          >
            <FontAwesomeIcon icon="poll" size="2x" />
          </Button>
          {mappedStatus}
          {mappedTime}

          {showAnswers ? (
            <TeacherModuleAnswersAndDocs
              module={props.module}
              answersAvaliable={props.answersAvailable}
            />
          ) : null}
          {showStudyTasks ? (
            <Button
              outline
              size="sm"
              className="d-flex align-items-center overflow-hidden study-tasks-btn"
              color="primary"
              title={props.intl.formatMessage({ id: "StudyTasks" })}
              onClick={handleOpenStudyTasks}
            >
              <FileDownloadIcon className="fs-6 flex-shrink-0 mt-1 me-1" />
              <span className="text-truncate">
                <FormattedMessage id="StudyTasks" />
              </span>
            </Button>
          ) : null}
        </div>
      </div>
    </ListGroupItem>
  );
};

export default injectIntl(TeacherModule);
